import React from "react";
import { Input } from "semantic-ui-react";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { CopyToClipboardTooltip } from "./CopyToClipboardTooltip";
import { PhosphorCopy } from "./PhosphorIcon";

interface CopyToClipboardProps {
  value: string
}

const CopyToClipboard = ({ value }: CopyToClipboardProps) => {
  const semantiRef = useSemanticUiInputRef();

  const afterCopy = () => {
    setTimeout(() => {
      semantiRef.ref.current.focus();
    }, 1);
  }

  return <Input
    style={{ position: "relative" }}
    fluid
    label={<CopyToClipboardTooltip>
      {(copy) => <div className="ui label basic copy-to-clipboard-button" onClick={() => { copy(value); afterCopy(); }}>
        <PhosphorCopy />
      </div>}
    </CopyToClipboardTooltip>
    }
    labelPosition="right"
    value={value}
  />
}

export default CopyToClipboard;
